import { Routes } from '@angular/router';

import { codesRoutes } from './app.routes.codes';
import { companiesRoutes } from './app.routes.companies';
import { nhfRoutes } from './app.routes.nhf';
import { procedureSetsRoutes } from './app.routes.procedure-sets';
import { procedureRoutes } from './app.routes.procedures';
import { serviceProviderRoutes } from './app.routes.service-providers';
import { userRoutes } from './app.routes.users';
import { ErrorPage } from './core/pages/error/error-page/error-page';
import { ErrorLayout } from './core/pages/layout/error-layout/error-layout';
import { MainLayoutComponent } from './core/pages/layout/main-layout/main-layout';
import { SingleLayout } from './core/pages/layout/single-layout/single-layout';
import { LoginOidcComponent } from './core/pages/login-oidc/login-oidc';
import { Login } from './core/pages/login/login';
import { LogoutOidcComponent } from './core/pages/logout-oidc/logout-oidc';
export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'companies',
        pathMatch: 'full',
      },
      ...companiesRoutes,
      ...nhfRoutes,
      ...userRoutes,
      ...codesRoutes,
      ...serviceProviderRoutes,
      ...procedureRoutes,
      ...procedureSetsRoutes,
    ],
  },
  {
    path: '',
    component: SingleLayout,
    children: [
      {
        path: 'login',
        component: Login,
      },
    ],
  },
  {
    path: 'error',
    component: ErrorLayout,
    children: [
      {
        path: ':code',
        component: ErrorPage,
      },
    ],
  },
  {
    path: 'login-oidc',
    component: LoginOidcComponent,
  },
  {
    path: 'logout-oidc',
    component: LogoutOidcComponent,
  },
];
